module.exports = __webpack_public_path__ + "static/people_img26-1e6382f4ee707ba887d588691e29d320.png";